import { render, staticRenderFns } from "./DaDashBoard.vue?vue&type=template&id=da5887e6&"
import script from "./DaDashBoard.vue?vue&type=script&lang=ts&"
export * from "./DaDashBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports